import Header from './utill/Header';
import Footer from './utill/Footer';
import Sidebar from './utill/Sidebar';
import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import {Card, Form, Table} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import Url from "./utill/Url";
import axios from "axios";
import {useSelector} from "react-redux";
import {reissue} from "./utill/UtilComponent";
import {
    Paper,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import { RootState } from '../redux/store';
import StyledTableCell from "./utill/StyledTableCell"

interface AppVersion{
    os: string;
    version: string;
    isUpdate: string;
}

function AppVersionManagement() {

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-앱 버전 관리'
    })

    const url = useContext(Url);
    const navigate = useNavigate();
    const [data, setData] = useState<AppVersion[]>([]);
    const user = useSelector((state: RootState) => state.user.value);
    const auth = useSelector((state: RootState) => state.loginAuth.value);
    const [writeAuthorityYn, setWriteAuthorityYn] = useState(false);

    let userId = user.id;

    useEffect(() => {
        if (auth.MENUAUTH?.AVER0000?.writeAuthorityYn && auth.MENUAUTH?.AVER0000?.readAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'admin/find/appversion', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
                .then((response) => {
                    setData(response.data.result)
                })
        });
        setWriteAuthorityYn(auth.MENUAUTH?.AVER0000?.writeAuthorityYn === "1")
    }, []);

    const handleUpdateVersion = async (e: React.MouseEvent<HTMLButtonElement>) => {
        reissue(userId, url, navigate).then(() => {
            e.preventDefault();
            const Update = window.confirm('기기의 버전을 수정하시겠습니까?')
            if (Update) {
                axios.put(url + 'admin/update/appversion',data,
                    {
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    })
                    .then(res => {
                        window.location.reload();
                    })
                    .catch(error => {
                        console.log(error);
                        alert('버전 수정에 실패하였습니다.');
                    });
            } else {
                console.log(e);
            }
        })
    }

    const handleVersionChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, os: string) => {
        const versionValue = event.target.value;
        const updatedData = data.map(item => {
            if (item.os === os) {
                return { ...item, version: versionValue }; // os가 일치하면 version을 업데이트
            }
            return item;
        });
        setData(updatedData)
    }

    const handleUpdateChange = (event: ChangeEvent<HTMLSelectElement>, os: string) => {
        const updateValue = event.target.value;
        const updatedData = data.map(item => {
            if (item.os === os) {
                return { ...item, isUpdate: updateValue };
            }
            return item;
        });
        setData(updatedData)
    }



    const handleModifyCancel = () => {
        reissue(userId, url, navigate).then(() => {
            const Cancel = window.confirm('취소하시겠습니까? 수정중인 내용이 모두 삭제됩니다.');
            if (Cancel) {
                reissue(userId, url, navigate).then(() => {
                    axios.get(url + 'admin/find/appversion', {
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    })
                        .then((response) => {
                            setData(response.data.result)
                        })
                })
            }
        })
    }

    

    return (
        <div id="wrapper">
            <Sidebar menuCode={"AVER0000"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='앱 버전 관리'/>
                        <p className="header-message">OS의 앱 버전을 관리 합니다.</p>
                        <Card className="card shadow mb-4" style={{minHeight: "670px"}}>
                            <Card.Body style={{margin:'1rem'}}>
                                <TableContainer component={Paper}>
                                    <Table style={{marginBottom: 0}} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="center" style={{width: "20rem"}}>OS</StyledTableCell>
                                                <StyledTableCell align="center" style={{width: "70rem"}}>Version</StyledTableCell>
                                                <StyledTableCell align="center" style={{width: "10rem"}}>Update</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        {writeAuthorityYn ? (<TableBody>
                                            {data.map((data) => (
                                                <TableRow key={data.os}>
                                                    <StyledTableCell align="center">{data.os}</StyledTableCell>
                                                    <TableCell align="center"><Form.Control type="text" name="version"
                                                                                            onChange={(event) => handleVersionChange(event, data.os)}
                                                                                            value={data.version}/></TableCell>
                                                    <TableCell align="center">
                                                        <Form.Select name="isUpdate" value={data.isUpdate} onChange={(event) => handleUpdateChange(event, data.os)}>
                                                            <option value="y">y</option>
                                                            <option value="n">n</option>
                                                        </Form.Select>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>) : (<TableBody>
                                            {data.map((data) => (
                                                <TableRow key={data.os}>
                                                    <StyledTableCell align="center">{data.os}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.version}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.isUpdate}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>)}
                                    </Table>
                                </TableContainer>
                                {writeAuthorityYn && <div className="btn modify">
                                    <button className="btn btn-primary" onClick={handleUpdateVersion}>수정</button>
                                    <button className="btn btn-secondary cancel" onClick={handleModifyCancel}>취소</button>
                                </div>}
                            </Card.Body>
                        </Card>
                        <div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}



export default AppVersionManagement;